import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login.vue'
import CustomerAdmin from '@/views/Customer/CustomerAdmin.vue'
import CustomerEdition from '@/views/Customer/CustomerEdition.vue'
import ErrorView from '@/views/Error.vue'
import OrdersAdmin from '@/views/Orders/OrdersAdmin.vue'
import OrdersEdition from '@/views/Orders/OrdersEdition.vue'
import CarrierCompanyAdmin from '@/views/Transport/CarrierCompanyAdmin.vue'
import CarrierCompanyEdition from '@/views/Transport/CarrierCompanyEdition.vue'
import ProductAdmin from '@/views/Product/ProductAdmin.vue'
import ProductEdition from '@/views/Product/ProductEdition.vue'
import LabelAdmin from '@/views/Label/LabelAdmin.vue'
import LabelEdition from '@/views/Label/LabelEdition.vue'
import PalletAdmin from '@/views/Pallet/PalletAdmin.vue'
import FieldAdmin from '@/views/Field/FieldAdmin.vue'
import FieldEdition from '@/views/Field/FieldEdition.vue'
import FieldSiteAdmin from '@/views/FieldSite/FieldSiteAdmin.vue'
import FieldSiteEdition from '@/views/FieldSite/FieldSiteEdition.vue'
import ProducerAdmin from '@/views/Producer/ProducerAdmin.vue'
import ProducerEdition from '@/views/Producer/ProducerEdition.vue'
import ProductionAdmin from '@/views/Campaign/ProductionAdmin.vue'
import ProductionEdition from '@/views/Campaign/ProductionEdition.vue'
import VariableAdmin from '@/views/Variable/VariableAdmin.vue'
import VariableEdition from '@/views/Variable/VariableEdition.vue'
import EventAdmin from '@/views/Event/EventAdmin.vue'
import EventEdition from '@/views/Event/EventEdition.vue'
import ResearchOrderAdmin from '@/views/I&D/ResearchOrderAdmin.vue'
import ResearchOrderEdition from '@/views/I&D/ResearchOrderEdition.vue'
import SupplierAdmin from '@/views/Supplier/SupplierAdmin.vue'
import SupplierEdition from '@/views/Supplier/SupplierEdition.vue'
import UserAdmin from '@/views/User/UserAdmin.vue'
import UserEdition from '@/views/User/UserEdition.vue'
import ExportAdmin from '@/views/Export/ExportAdmin.vue'
import Consolidated from '@/views/Export/Consolidated.vue'
import StockMovementHistory from '@/views/StockMovement/StockMovementHistory.vue'
import Dashboard from './views/Dashboard/Dashboard.vue'
import LookerDashboard from './views/Dashboard/LookerDashboard.vue'
import LookerDashboardLargeProduction from './views/Dashboard/LookerDashboardLargeProduction.vue'
import DMDashboard from './views/Dashboard/DMDashboard.vue'
import RFMDashboard from './views/Dashboard/RFMDashboard.vue'
import IconsShowcase from './views/Dashboard/IconsShowcase.vue'
import CampaignAdmin from '@/views/Campaign/CampaignAdmin.vue'
import CampaignEdition from '@/views/Campaign/CampaignEdition.vue'
import FieldSection from '@/views/Field/FieldSection.vue'
import StockTransferAdmin from '@/views/StockTransfer/StockTransferAdmin.vue'



import store from '@/store.js'

const orderRoutes = [
  {
    path: '/',
    redirect:'ordersAdmin',
  },
  {
    path: "/ordersAdmin",
    name: 'OrdersAdmin',
    component: OrdersAdmin,
  },

  {
    path: '/',
    redirect:'ordersEdition',
  },
  {
    path: '/ordersEdition/:id',
    name: 'OrdersEdition',
    component: OrdersEdition,
    props: true,
  },
];

const transportRoutes = [
  {
    path: '/',
    redirect:'carrierCompanyAdmin',
  },
  {
    path: "/carrierCompanyAdmin",
    name: 'CarrierCompanyAdmin',
    component: CarrierCompanyAdmin,
  },

  {
    path: '/',
    redirect:'carrierCompanyEdition',
  },
  {
    path: '/carrierCompanyEdition/:id',
    name: 'CarrierCompanyEdition',
    component: CarrierCompanyEdition,
    props: true,
  },
];

const productRoutes = [
  {
    path: '/',
    redirect:'productAdmin',
  },
  {
    path: "/productAdmin",
    name: 'ProductAdmin',
    component: ProductAdmin,
  },

  {
    path: '/',
    redirect:'productEdition',
  },
  {
    path: '/productEdition/:id',
    name: 'ProductEdition',
    component: ProductEdition,
    props: true,
  },
];

const labelsRoutes = [
  {
    path: '/',
    redirect:'labelAdmin',
  },
  {
    path: "/labelAdmin",
    name: 'LabelAdmin',
    component: LabelAdmin,
  },

  {
    path: '/',
    redirect:'labelEdition',
  },
  {
    path: '/labelEdition/:id',
    name: 'LabelEdition',
    component: LabelEdition,
    props: true,
  },
];

const palletsRoutes = [
  {
    path: '/',
    redirect:'palletAdmin',
  },
  {
    path: "/palletAdmin",
    name: 'PalletAdmin',
    component: PalletAdmin,
  },
];

const fieldsRoutes = [
  {
    path: '/',
    redirect:'fieldAdmin',
  },
  {
    path: "/fieldAdmin",
    name: 'FieldAdmin',
    component: FieldAdmin,
  },

  {
    path: '/',
    redirect:'fieldEdition',
  },
  {
    path: '/fieldEdition/:id',
    name: 'FieldEdition',
    component: FieldEdition,
    props: true,
  },
];

const fieldSitesRoutes = [
  {
    path: '/',
    redirect:'fieldSiteAdmin',
  },
  {
    path: "/fieldSiteAdmin",
    name: 'FieldSiteAdmin',
    component: FieldSiteAdmin,
  },

  {
    path: '/',
    redirect:'fieldSiteEdition',
  },
  {
    path: '/fieldSiteEdition/:id',
    name: 'FieldSiteEdition',
    component: FieldSiteEdition,
    props: true,
  },
];

const dashboardRoutes = [

  {
    path: "/dashboard",
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: "/consolidated",
    name: 'Consolidated',
    component: Consolidated,
  },
  {
    path: "/lookerDashboard",
    name: 'lookerDashboard',
    component: LookerDashboard,
  },
  {
    path: "/lookerDashboardLargeProduction",
    name: 'lookerDashboardLargeProduction',
    component: LookerDashboardLargeProduction,
  },
  {
    path: "/dmDashboard",
    name: 'DMDashboard',
    component: DMDashboard
  },
  {
    path: "/rfmDashboard",
    name: 'RFMDashboard',
    component: RFMDashboard
  },
  {
    path: "/IconsShowcase",
    name: 'IconsShowcase',
    component: IconsShowcase,
    props: true,
  },
];


const producerRoutes = [
  {
    path: '/',
    redirect:'producerAdmin',
  },
  {
    path: "/producerAdmin",
    name: 'ProducerAdmin',
    component: ProducerAdmin,
  },

  {
    path: '/',
    redirect:'producerEdition',
  },
  {
    path: '/producerEdition/:id',
    name: 'ProducerEdition',
    component: ProducerEdition,
    props: true,
  },
];

const customerRoutes = [
  {
    path: '/',
    redirect:'customerAdmin',
  },
  {
    path: "/customerAdmin",
    name: 'CustomerAdmin',
    component: CustomerAdmin,
  },
  
  {
    path: '/customerEdition/:id',
    name: 'CustomerEdition',
    component: CustomerEdition,
    props: true,
  },
];


const supplierRoutes = [
  {
    path: '/',
    redirect:'supplierAdmin',
  },
  {
    path: "/supplierAdmin",
    name: 'SupplierAdmin',
    component: SupplierAdmin,
  },
  
  {
    path: '/supplierEdition/:id',
    name: 'SupplierEdition',
    component: SupplierEdition,
    props: true,
  },
];

const ProductionRoutes = [
  {
    path: '/',
    redirect:'productionAdmin',
  },
  {
    path: "/productionAdmin",
    name: 'ProductionAdmin',
    component: ProductionAdmin,
  },

  {
    path: '/productionEdition/:id',
    name: 'ProductionEdition',
    component: ProductionEdition,
    props: true,
  },
];


const VariableRoutes = [
  {
    path: '/',
    redirect:'variableAdmin',
  },
  {
    path: "/variableAdmin",
    name: 'VariableAdmin',
    component: VariableAdmin,
  },

  {
    path: '/variableEdition/:id',
    name: 'VariableEdition',
    component: VariableEdition,
    props: true,
  },

];

const EventRoutes = [
  {
    path: '/',
    redirect:'eventAdmin',
  },
  {
    path: "/eventAdmin",
    name: 'EventAdmin',
    component: EventAdmin,
  },

  {
    path: '/eventEdition/:id',
    name: 'EventEdition',
    component: EventEdition,
    props: true,
  },

];

const IandDRoutes = [
  {
    path: '/',
    redirect:'researchOrderAdmin',
  },
  {
    path: "/researchOrderAdmin",
    name: 'ResearchOrderAdmin',
    component: ResearchOrderAdmin,
  },

  {
    path: '/researchOrderEdition/:id',
    name: 'ResearchOrderEdition',
    component: ResearchOrderEdition,
    props: true,
  },

];

const UserRoutes = [
  {
    path: '/',
    redirect:'userAdmin',
  },
  {
    path: "/userAdmin",
    name: 'UserAdmin',
    component: UserAdmin,
  },

  {
    path: '/userEdition/:userId',
    name: 'UserEdition',
    component: UserEdition,
    props: true,
  },

];

const ExportRoutes = [
  {
    path: '/',
    redirect:'exportAdmin',
  },
  {
    path: "/exportAdmin",
    name: 'ExportAdmin',
    component: ExportAdmin,
  },
  {
    path: "/stockMovementHistory",
    name: 'StockMovementHistory',
    component: StockMovementHistory,
  },
];

const CampaignRoutes = [
  {
    path: '/',
    redirect:'campaignAdmin',
  },
  {
    path: "/campaignAdmin",
    name: 'CampaignAdmin',
    component: CampaignAdmin,
  },
  {
    path: "/campaignEdition/:id",
    name: 'CampaignEdition',
    component: CampaignEdition,
    props: true,
  }
];

const FieldSectionRoutes = [
  {
    path: '/',
    redirect:'fieldSection',
  },
  {
    path: "/fieldSection",
    name: 'FieldSection',
    component: FieldSection,
  },
];

const StockTransferRoutes = [
  {
    path: '/',
    redirect:'stockTransferAdmin',
  },
  {
    path: "/stockTransferAdmin",
    name: 'StockTransferAdmin',
    component: StockTransferAdmin,
  }
];

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: "/login",
      name: 'login',
      component: Login
    },
    {
      path: "/error",
      name: 'error',
      component: ErrorView
    },
    ...orderRoutes,
    ...transportRoutes,
    ...palletsRoutes,
    ...productRoutes,
    ...labelsRoutes,
    ...fieldsRoutes,
    ...fieldSitesRoutes,
    ...producerRoutes,
    ...ProductionRoutes,
    ...VariableRoutes,
    ...EventRoutes,
    ...IandDRoutes,
    ...customerRoutes,
    ...supplierRoutes,
    ...UserRoutes,
    ...ExportRoutes,
    ...dashboardRoutes,
    ...CampaignRoutes,
    ...FieldSectionRoutes,
    ...StockTransferRoutes
  ],
});

router.beforeEach((to, from, next) => {
  var VueCookie = require('vue-cookie');
  var cookieUser = VueCookie.get('pc_authentication');
  var cookieError = VueCookie.get('pc_error');
  let i18n = store.get("i18nStore/valuesRetrieved")
  let sysp = store.get("config/globalParameters")

  const selectedLanguage = VueCookie.get('selectedLanguage') || 'es';
  
  const applyContextFromQuery = () => {
    // Pick up fieldSiteId/campaignId from deep links and set globals once
    const fieldSiteId = to && to.query && to.query.fieldSiteId ? Number(to.query.fieldSiteId) : null;
    const campaignId = to && to.query && to.query.campaignId ? Number(to.query.campaignId) : null;
    const promises = [];
    if (fieldSiteId && !isNaN(fieldSiteId)) {
      const currentFs = store.get("globalFieldSite");
      if (!currentFs || currentFs.id !== fieldSiteId) {
      promises.push(store.dispatch("fieldSite/retrieveFieldSiteById", fieldSiteId).then((res) => {
        store.commit("updateGlobalFieldSite", res);
        VueCookie.set("globalFieldSiteId", fieldSiteId);
      }));
      }
    }
    if (campaignId && !isNaN(campaignId)) {
      const currentCamp = store.get("globalCampaign");
      if (!currentCamp || currentCamp.id !== campaignId) {
      promises.push(store.dispatch("campaign/retrieveCampaignById", { id: campaignId }).then((res) => {
        store.commit("updateGlobalCampaign", res);
        VueCookie.set("globalCampaignId", campaignId);
      }));
      }
    }
    if (promises.length > 0) {
      Promise.all(promises).finally(() => next());
      return true;
    }
    return false;
  };

  if (sysp && sysp.length != 0 && i18n && Object.keys(i18n).length > 0) {
    if (applyContextFromQuery()) return; // defer next() until context set
    let authMode = sysp['authMode'];
    if (cookieUser) {
      next();
    } else if (to.name == 'error') {
      next();
    } else if (to.name == 'login' && (authMode == 'dummy' || authMode == 'db')) {
      next();
    } else if (cookieError) {
      next({ name: 'error' });
      VueCookie.delete('pc_error');
    } else if (authMode == 'dummy' || authMode == 'db') {
      next({ name: 'login' });
    } else {
      next({ name: 'error' });
    }
  }else{
    store.dispatch("i18nStore/changeI18n", selectedLanguage).then(() => {
      store.dispatch("config/retrieve").then(() => {
        sysp = store.get("config/globalParameters");
        let authMode = sysp['authMode'];
        if (cookieUser) {
          if (applyContextFromQuery()) return; // defer next() until context set
          next();
        } else if (to.name == 'error') {
          next();
        } else if (to.name == 'login' && (authMode == 'dummy' || authMode == 'db')) {
          next();
        } else if (cookieError) {
          next({ name: 'error' });
          VueCookie.delete('pc_error');
        } else if (authMode == 'dummy' || authMode == 'db') {
          next({ name: 'login' });
        } else {
          next({ name: 'error' });
        }
      });
    });
  }
})

export default router;
